module.exports = __webpack_public_path__ + "img/adbros-logo.6496ca5.svg";